import { withAuthHeaders } from "./auth";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export const appointmentApiUrl = (path = "") =>
  `${BASE}/${String(path).replace(/^\/+/, "")}`;

export const createAppointment = async (doctorEmail, appointmentData) => {
  try {
    const encodedEmail = encodeURIComponent(doctorEmail?.toLowerCase());

    const response = await fetch(
      appointmentApiUrl(`/api/appointments/${encodedEmail}/custom/appointment`),
      {
        method: "POST",
        headers: withAuthHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(appointmentData),
      }
    );

    if (!response.ok) {
      const err = await response.text();

      let errorResponse;

      try {
        errorResponse = JSON.parse(err);
      } catch {
        errorResponse = null;
      }

      const errorMessage =
        errorResponse?.error?.message ||
        errorResponse?.error ||
        errorResponse?.message ||
        err ||
        "Failed to create appointment";

      throw new Error(`Failed to create: ${errorMessage}`);
    }

    const result = await response.json();

    if (
      result?.success === true &&
      Object.prototype.hasOwnProperty.call(result, "data")
    ) {
      return result.data;
    }

    return result;
  } catch (error) {
    console.error("Create appointment error:", error);
    throw error;
  }
};

export const updateAppointment = async (doctorEmail, id, appointmentData) => {
  try {
    const encodedEmail = encodeURIComponent(doctorEmail?.toLowerCase());

    const response = await fetch(
      appointmentApiUrl(`/api/appointments/${encodedEmail}/appointment/${id}`),
      {
        method: "PATCH",
        headers: withAuthHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(appointmentData),
      }
    );

    if (!response.ok) {
      const errText = await response.text();

      let errorResponse;

      try {
        errorResponse = JSON.parse(errText);
      } catch {
        errorResponse = null;
      }

      const errorMessage =
        errorResponse?.error?.message ||
        errorResponse?.error ||
        errorResponse?.message ||
        errText ||
        "Failed to update appointment";

      throw new Error(`Failed to update: ${errorMessage}`);
    }

    try {
      const result = await response.json();

      if (
        result?.success === true &&
        Object.prototype.hasOwnProperty.call(result, "data")
      ) {
        return result.data;
      }

      return result;
    } catch {
      return { success: true };
    }
  } catch (error) {
    console.error("Update appointment error:", error);
    throw error;
  }
};

export const cancelAppointment = async (doctorEmail, id, payload = {}) => {
  try {
    const encodedEmail = encodeURIComponent(doctorEmail?.toLowerCase());

    const response = await fetch(
      appointmentApiUrl(`/api/appointments/${encodedEmail}/cancel/${id}`),
      {
        method: "PATCH",
        headers: withAuthHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errText = await response.text();

      let errorResponse;

      try {
        errorResponse = JSON.parse(errText);
      } catch {
        errorResponse = null;
      }

      const errorMessage =
        errorResponse?.error?.message ||
        errorResponse?.error ||
        errorResponse?.message ||
        errText ||
        "Failed to cancel appointment";

      throw new Error(`Failed to cancel: ${errorMessage}`);
    }

    return true;
  } catch (error) {
    console.error("Cancel appointment error:", error);
    throw error;
  }
};

export const pullAthenaAppointments = async (doctorEmail, practiceId, providerId, departmentId = "150") => {
  try {
    const encodedEmail = encodeURIComponent(doctorEmail?.toLowerCase());
    const response = await fetch(
      appointmentApiUrl(`/api/appointments/${encodedEmail}/pull`),
      {
        method: "POST",
        headers: withAuthHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({
          practice_id: practiceId,
          provider_id: providerId,
          department_id: departmentId,
        }),
      }
    );
    if (!response.ok) {
      const errText = await response.text();

      let errorResponse;

      try {
        errorResponse = JSON.parse(errText);
      } catch {
        errorResponse = null;
      }

      const errorMessage =
        errorResponse?.error?.message ||
        errorResponse?.error ||
        errorResponse?.message ||
        errText ||
        "Failed to pull appointments";

      throw new Error(`Failed to pull appointments: ${errorMessage}`);
    }

    const result = await response.json();

    if (
      result?.success === true &&
      Object.prototype.hasOwnProperty.call(result, "data")
    ) {
      return result.data;
    }

    return result;
  } catch (error) {
    console.error("Pull Athena appointments error:", error);
    throw error;
  }
};

export const deleteAppointment = async (doctorEmail, id, appointment_date) => {
  try {
    const encodedEmail = encodeURIComponent(doctorEmail?.toLowerCase());

    const response = await fetch(
      appointmentApiUrl(`/api/appointments/${encodedEmail}/appointment/${id}`),
      {
        method: "DELETE",
        headers: withAuthHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify({ appointment_date }),
      }
    );

    if (!response.ok) {
      const errText = await response.text();

      let errorResponse;

      try {
        errorResponse = JSON.parse(errText);
      } catch {
        errorResponse = null;
      }

      const errorMessage =
        errorResponse?.error?.message ||
        errorResponse?.error ||
        errorResponse?.message ||
        errText ||
        "Failed to delete appointment";

      throw new Error(`Failed to delete: ${errorMessage}`);
    }

    return true;
  } catch (error) {
    console.error("Delete appointment error:", error);
    throw error;
  }
};